module.exports = __webpack_public_path__ + "img/RepGuideLogoWhite.0b0f0211.svg";